export default class stringHelper {

  static truncate(s, n, useWordBoundary) {
    if (!s) {
      return '';
    }
    let isTooLong = s.length > n,
      s_ = isTooLong ? s.substr(0, n - 1) : s;
    s_ = (useWordBoundary && isTooLong) ? s_.substr(0, s_.lastIndexOf(' ')) : s_;
    return isTooLong ? s_ + '…' : s_;
  }

  static slugify(text) {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }

  static optimizeHtml(html) {
    return html.replace(/<a /g, '<a target="_blank" ');
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/stringHelper.js
 **/